// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom_report_mainbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.custom_report_mainbox .custom_report_selector {
  width: 80%;
}
.custom_report_mainbox .custom_report_selector .custom_report_selector_row {
  display: flex;
  align-items: center;
  justify-content: start;
}
.custom_report_mainbox .custom_report_selector .compare_month_report_box {
  padding: 10px;
  background-color: #e3f2fd;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.custom_report_mainbox .custom_report_selector .compare_month_report_box .col-md-6:first-child {
  padding-left: 0;
}
.custom_report_mainbox .custom_report_selector .compare_month_report_box .col-md-6:last-child {
  padding-right: 0;
}
.custom_report_mainbox .custom_report_button {
  width: 20%;
  display: flex;
  justify-content: center;
}
@media screen and (max-width: 768px) {
  .custom_report_mainbox {
    flex-direction: column;
    flex-wrap: wrap;
  }
  .custom_report_mainbox .custom_report_selector {
    width: 100%;
  }
  .custom_report_mainbox .custom_report_selector .compare_month_report_box {
    margin-top: 10px;
  }
  .custom_report_mainbox .custom_report_button {
    width: 100%;
  }
}

.dashboard__customersCard .dashboard__body {
  min-height: 450px;
}

.cs_report_mainbox {
  display: flex;
  align-items: start;
  justify-content: start;
}
.cs_report_mainbox .cs_report_box {
  width: calc(33.3333333333% - 10px);
  margin-right: 10px;
  position: relative;
}
.cs_report_mainbox .cs_report_box .cs_reports_mainbox {
  display: none;
}
.cs_report_mainbox .cs_report_box .cs_reports_mainbox.active {
  display: block;
  width: 100%;
  position: absolute;
}
.cs_report_mainbox .cs_report_box .cs_reports_mainbox .cs_report_box_results .cs_report_space {
  margin-top: 10px;
}
.cs_report_mainbox .cs_report_box .cs_reports_mainbox .cs_report_box_results .cs_report_btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
}
.cs_report_mainbox .cs_report_box .cs_reports_mainbox .cs_report_box_results .cs_report_btns .reseter_btn {
  display: flex;
  width: calc(50% - 5px);
  margin-right: 5px;
}
.cs_report_mainbox .cs_report_box .cs_reports_mainbox .cs_report_box_results .cs_report_btns .reseter_btn:last-child {
  margin-right: 0;
}
.cs_report_mainbox .cs_report_box .cs_reports_mainbox .cs_report_box_results .cs_report_btns .reseter_btn button {
  padding: 10px;
  border: none;
  width: 100%;
  background-color: #E5E4E2;
  border-radius: 4px;
  color: #000;
  font-weight: 600;
  cursor: pointer;
}
.cs_report_mainbox .cs_report_box .cs_reports_mainbox .cs_report_box_results .cs_report_btns .reseter_btn button:hover {
  background-color: #DBD7D2;
}
.cs_report_mainbox .cs_report_box .cs_report_box_header {
  background-color: #E5E4E2;
  color: #000;
  font-weight: 600;
  padding: 15px;
  border-radius: 4px;
  position: relative;
  align-items: center;
  display: flex;
  cursor: pointer;
}
.cs_report_mainbox .cs_report_box .cs_report_box_header:hover {
  background-color: #DBD7D2;
}
.cs_report_mainbox .cs_report_box .cs_report_box_header:after {
  content: "";
  width: 12px;
  height: 12px;
  display: inline-block;
  border: none;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  position: absolute;
  right: 15px;
  transform: rotate(45deg);
}
.cs_report_mainbox .cs_report_box .cs_report_box_results {
  padding: 15px;
  background-color: #FFF;
  border-bottom-left-radius: 8px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-bottom-right-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/styles/custom_report.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AACI;EACI,UAAA;AACR;AACQ;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;AACZ;AAEQ;EACI,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AAAZ;AAIgB;EACI,eAAA;AAFpB;AAIgB;EACI,gBAAA;AAFpB;AAQI;EACI,UAAA;EACA,aAAA;EACA,uBAAA;AANR;AASI;EAtCJ;IAuCQ,sBAAA;IACA,eAAA;EANN;EAQM;IACI,WAAA;EANV;EAQU;IACI,gBAAA;EANd;EAUM;IACI,WAAA;EARV;AACF;;AAeI;EAEI,iBAAA;AAbR;;AAiBA;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;AAdJ;AAgBI;EACI,kCAAA;EACA,kBAAA;EACA,kBAAA;AAdR;AAgBQ;EACI,aAAA;AAdZ;AAgBY;EACI,cAAA;EACA,WAAA;EACA,kBAAA;AAdhB;AAoBgB;EACI,gBAAA;AAlBpB;AAqBgB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAnBpB;AAqBoB;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;AAnBxB;AAqBwB;EACI,eAAA;AAnB5B;AAsBwB;EACI,aAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AApB5B;AAsB4B;EACI,yBAAA;AApBhC;AA4BQ;EACI,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AA1BZ;AA4BY;EACI,yBAAA;AA1BhB;AA6BY;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,wBAAA;AA3BhB;AAgCQ;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iDAAA;EACA,+BAAA;AA9BZ","sourcesContent":[".custom_report_mainbox{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    .custom_report_selector{\r\n        width: 80%;\r\n\r\n        .custom_report_selector_row{\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: start;\r\n        }\r\n\r\n        .compare_month_report_box{\r\n            padding: 10px;\r\n            background-color: #e3f2fd;\r\n            border-radius: 4px;\r\n            border: 1px solid #ccc;\r\n\r\n            .col-md-6{\r\n\r\n                &:first-child{\r\n                    padding-left: 0;\r\n                }\r\n                &:last-child{\r\n                    padding-right: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .custom_report_button{\r\n        width: 20%;\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n\r\n    @media screen and (max-width: 768px) {\r\n        flex-direction: column;\r\n        flex-wrap: wrap;\r\n\r\n        .custom_report_selector{\r\n            width: 100%;\r\n\r\n            .compare_month_report_box{\r\n                margin-top: 10px;\r\n            }\r\n        }\r\n\r\n        .custom_report_button{\r\n            width: 100%;\r\n        }\r\n\r\n    }\r\n}\r\n\r\n.dashboard__customersCard{\r\n\r\n    .dashboard__body{\r\n\r\n        min-height: 450px;\r\n    }    \r\n}\r\n\r\n.cs_report_mainbox{\r\n    display: flex;\r\n    align-items: start;\r\n    justify-content: start;\r\n\r\n    .cs_report_box{\r\n        width: calc(100%/3 - 10px);\r\n        margin-right: 10px;\r\n        position: relative;\r\n\r\n        .cs_reports_mainbox{\r\n            display: none;\r\n\r\n            &.active{                \r\n                display: block;\r\n                width: 100%;\r\n                position: absolute;\r\n            \r\n            }\r\n\r\n            .cs_report_box_results{\r\n\r\n                .cs_report_space{\r\n                    margin-top: 10px;\r\n                }\r\n\r\n                .cs_report_btns{\r\n                    display: flex;\r\n                    justify-content: space-between;\r\n                    align-items: center;\r\n                    margin-top: 15px;\r\n\r\n                    .reseter_btn{\r\n                        display: flex;\r\n                        width: calc(50% - 5px);\r\n                        margin-right: 5px;\r\n\r\n                        &:last-child{\r\n                            margin-right: 0;\r\n                        }\r\n        \r\n                        button{\r\n                            padding: 10px;\r\n                            border: none;\r\n                            width: 100%;\r\n                            background-color: #E5E4E2;\r\n                            border-radius: 4px;\r\n                            color: #000;\r\n                            font-weight: 600;\r\n                            cursor: pointer;\r\n\r\n                            &:hover{\r\n                                background-color: #DBD7D2;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .cs_report_box_header{\r\n            background-color: #E5E4E2;\r\n            color: #000;\r\n            font-weight: 600;\r\n            padding: 15px;\r\n            border-radius: 4px;\r\n            position: relative;\r\n            align-items: center;\r\n            display: flex;\r\n            cursor: pointer;\r\n\r\n            &:hover{\r\n                background-color: #DBD7D2;\r\n            }\r\n\r\n            &:after{\r\n                content: '';\r\n                width: 12px;\r\n                height: 12px;\r\n                display: inline-block;\r\n                border: none;\r\n                border-right: 1px solid #000;\r\n                border-bottom: 1px solid #000;\r\n                position: absolute;\r\n                right: 15px;\r\n                transform: rotate(45deg);\r\n            }\r\n            \r\n        }\r\n\r\n        .cs_report_box_results{\r\n            padding: 15px;\r\n            background-color: #FFF;\r\n            border-bottom-left-radius: 8px;\r\n            box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n            border-bottom-right-radius: 8px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
